import React, {useState, useEffect, useRef} from 'react';
import { Button, Input, Link } from "@maxmilhas/hangar-components-atomic/public";
import { css } from 'emotion';
import { postCancellationProtocol, uploadImage, getCancellationTerm } from '../../../../shared/requests-api';
import { checkoutCredentials } from "../../../../shared/utils";
import moment from 'moment';

const overlay = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.4;
    background-color: #000;
    z-index: 9999;
`

const wrapper = `
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    padding: 0 16px 36px;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 99999;
    overflow-y: scroll;

    @media (min-width: 768px) {
        top: 50%;
        left: 50%;
        width: 100%;
        max-width: 530px;
        height: auto;
        max-height: 81vh;
        padding: 24px;
        border-radius: 8px;
        transform: translate(-50%, -50%);
    }
`

const termWrapper = `
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    padding: 0 16px 36px;
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    z-index: 99999;
    overflow-y: scroll;
    
    @media (min-width: 768px) {
        top: 50%;
        left: 50%;
        width: 100%;
        max-width: 530px;
        height: auto;
        max-height: 81vh;
        padding: 24px;
        border-radius: 8px;
        transform: translate(-50%, -50%);
        box-shadow: 0px 0px 7px
    }
`

const  closeButton = `
    align-self: flex-end;
    background: transparent;
    border: 0;
    appearance: none;

    @media (min-width: 1024px) {
        display: none;
    }

    i {
        font-size: 25px;
    }
`

const coverImage = `
    margin: 15px auto 0;
    width: 100%;

    @media (min-width: 768px) {
        width: 80%;
    }
`

const mainTitleStyle = `
    font-size: 16px;
    font-weight: bold;
    color: #223254;

    @media (min-width: 768px) {
        font-size: 20px;
    }
`

const titleStyle = `
    font-size: 16px;
    font-weight: bold;
    color: #223254;
`

const labelStyle = `
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    font-weight: 600;
`
const selectWrapperStyle = `
    position: relative;

    i {
        position: absolute;
        top: 27px;
        right: 20px;
        color: #1abc9c;
    }
`

const selectStyle = `
    margin-top: 8px;
    padding: 15px;
    width: 100%;
    font-size: 14px;
    color: #223254;
    border: 1px solid #c8ccd4;
    border-radius: 4px;
    background-color: #fff;
    appearance: none;

    &:after {
        content: '\e912';
        font-family: 'max-icons' !important;
        color: #1abc9c;
    }
`

const inputDateStyle = `
    margin-bottom: 15px;
    padding: 15px;
    width: 100%;
    font-size: 14px;
    font-weight: 600 !important;
    color: #223254 !important;
    border: 1px solid #c8ccd4;
    border-radius: 4px;
    background-color: #fff;
    appearance: none;
`

const textAreaStyle = `
    margin-top: 8px;
    padding: 15px;
    width: 100%;
    height: 145px;
    font-size: 14px;
    color: #223254;
    border: 1px solid #c8ccd4;
    border-radius: 4px;
    resize: none;
    background-color: #fff;
    appearance: none;

    &:placeholder {
        color: #6e798e;
    }
`

const infoListStyle = `
    padding: 0;
    list-style: none;
`

const infoParagraphStyle = `
    display: flex;
    align-item: flex-start;

    & i {
        font-size: 20px;
        margin-right: 15px;
    }
`

const radioWrapper = `
    margin-bottom: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const radioStyle = `
    display: none;

    & + label {
        display: flex;
        flex: 1;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: #223254;

        &:before {
            content: '';
            display: inline-block;
            width: 15px;
            height: 15px;
            margin-right: 10px;
            border: 3px solid #fff;
            border-radius: 50%;
            box-shadow: 0px 0px 0px 2px #6e798e;
            background-color: #fff;
            cursor: pointer;
        }
    }

    &:checked + label {
        &:before {
            content: '';
            box-shadow: 0px 0px 0px 2px #1abc9c;
            background-color: #1abc9c;
        }
    }
`

const termsWrapper = `
    display: flex;
    flex-align: felx-start;
    justify-content: flex-start;
`

const termsLink = `
    color: #1abc9c !important;
    text-decoration: undeline;
`

const buttonWrapper = `
    display: flex;
    align-items: center;
    justify-content: flex-end;
`

const cancelButtonStyle = `
    margin-right: 15px;
    max-width: 110px;
    font-weight: 600 !important;
    color: #1abc9c !important;
    background-color: #fff !important;
    box-shadow: none !important;
`

const sendButtonStyle = `
    border: 0;
    max-width: 192px;
    height: 48px;
    font-weight: 600 !important;
    box-shadow: none !important;

    &:disabled {
        background-color: #c8ccd4 !important;
    }
`

const fileInputStyle = `
    display: none !important;

    & + label {
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-height: 48px;
        color: #1abc9c;
        font-size: 14px;
        font-weight: 600;
        border: 1px solid #c8ccd4;
        border-radius: 4px;
        cursor: pointer;
    }
`

const fileList = `
    padding: 0;
    display: flex;
    flex-direction: column;
    list-style: none;
`

const fileItem = `
    display: flex;
    align-items: center;
    justify-content: space-between;
    
    p {
        flex: 1;
        font-size: 14px;
        color: #6e798e;
        font-weight: 600;
    }

    button {
        font-size: 24px;
        border: 0;
        background-color: none;
        appearance: none;
    }

    i {
        color: #1abc9c;
    }
`

const error = `
    margin: 5px 0;
    font-size: 14px;
    color: #fb3b3b;
    text-align: center;
`

const loading = `
    font-size: 16px;
    color: #1abc9c;
`

const submitedTitle = `
    color: #1abc9c;
`

const submitedParagraph = `
    margin-bottom: 20px;
`

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const CancellationForm = ({ order, protocolData, closeForm, isCorona, title, noShow}) => {
    const protocolKeys = Object.keys(protocolData);
    // states
    const [selectedOption, setSelectedOption] = useState({ ...protocolData[protocolKeys[0]], reasonCode: protocolKeys[0]})
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [formSubmited, setFormSubmited] = useState(false);
    const [showTerm, setShowTerm] = useState(false);
    const [isButtonEnable, handleButton] = useState(false);
    const [fileErrorMessage, setFileErrorMessage] = useState('');
    const [generalError, setGeneralError] = useState('');
    const [loadingMessage, setLoadingMessage] = useState('');
    const [isCheckboxChecked, setCheckboxChecked] = useState(false);
    const [fetchingTerms, setFetchingTerms] = useState(false);
    const [term, setTerm] = useState();
    const [termVars, setTermVars] = useState();
    const [termsError, setTermsError] = useState();

    const { info, documents, choices } = selectedOption;
    const textField = selectedOption['text-box'];
    // order code
    const { code } = order.order;

    // reason titles
    const reasons = Object.values(protocolData).map((reason, i) => reason.title);

    // refs
    const selectEl = useRef();
    const textArea = useRef();
    const fileInput = useRef();
    const dateInput = useRef();

    const today = moment().format('YYYY/MM/DD');
    const limitDate = moment(order.flights.outbound.departureDate.split(' ')[0], 'DD/MM/YYYY').add(1, 'year').format('YYYY/MM/DD');

    useEffect(() => {
        const { justification, reasonOption, rescheduleDate } = selectedOption;

        if (documents && selectedFiles.length < 1) {
            handleButton(false);
        } else if (choices && !reasonOption) {
            handleButton(false);
        } else if (isCorona && reasonOption === 'reschedule' && (rescheduleDate === '' || rescheduleDate === 'Invalid date' || rescheduleDate < today || rescheduleDate > limitDate)) {
            if (rescheduleDate === 'Invalid date') {
                setGeneralError('A data selecionada é inválida');
            } else if (rescheduleDate > limitDate) {
                setGeneralError('A data não pode ser superior a 12 meses após a data de embarque');
            }

            handleButton(false);
        } else if (textField && (!justification || justification === '')) {
            setGeneralError('');
            handleButton(false);
        } else if (term && !isCheckboxChecked) {
            handleButton(false);
        } else {
            setGeneralError('');
            handleButton(true);
        }
    }, [selectedOption, selectedFiles, isCheckboxChecked, term])

    const updateSelectedReason = () => {
        setSelectedFiles([]);
        const key = selectEl.current.value;
        setSelectedOption({...protocolData[key], reasonCode: key});
    }

    const submitProtocol = e => {
        e.preventDefault();
        setGeneralError('');
        const { reasonCode, reasonOption, justification, rescheduleDate } = selectedOption;
        const orderCode = code;
        const filesReferenceIds = selectedFiles.map( item => item.referenceId );

        let data = { orderCode, reasonCode, reasonOption, flightDateSuggested: moment(rescheduleDate).format('DD/MM/YYYY'), justification, files: filesReferenceIds };

        if (term) {
            const { slug, currentVersion: { id: versionId } } = term;
            data = { ...data, term: { slug, currentVersion: { id: versionId }, vars: termVars } };
        }

        handleButton(false);

        postCancellationProtocol(data)
            .then(response => {
                setFormSubmited(true);
                handleButton(true);
            })
            .catch(err => {
                console.error(err);
                setGeneralError('Houve um erro ao tentar enviar sua solicitação, tente novamente.')
                handleButton(true);
            })
    }

    const uploadFiles = async () => {
        const files = fileInput.current.files;
        const fileArr = [];
        setFileErrorMessage('');
        setLoadingMessage('Carregando arquivos');

        for (const [i, file] of Array.from(files).entries() ) {
            if(file.size > 5000000) {
                setFileErrorMessage(`Tamanho máximo da imagem é de 5mb`);
                return
            }

            let result = await toBase64(file);
            result = result.split(',')[1];

            let uploadData = {
                fileName: file.name,
                fileExtension: file.type.split('/')[1],
                fileBase64: result
            };
            uploadData = JSON.stringify(uploadData);

            const response = await uploadImage(uploadData);

            if (response.status === 201) {
                fileArr.push({ name: file.name, referenceId: response.data.referenceId });
            }
        }
        setLoadingMessage('');
        setSelectedFiles([...selectedFiles, ...fileArr]);
    }

    const fetchTerms = (value) => {
        setCheckboxChecked(false);
        setFetchingTerms(true);
        setTerm(null);
        setTermVars(null);
        setTermsError(null);
        getCancellationTerm(checkoutCredentials().au, value === "cancel" ? "credit" : "rebooking", code)
            .then(res => {
                setFetchingTerms(false);
                setTerm(res.data.term);
                setTermVars(res.data.vars);
            }).catch(err => {
                setFetchingTerms(false);
                if (err.response) {
                    const { response: { status, data } } = err;
                    if (status !== 400 || (data && data.type !== "TermRuleNotFoundError")) {
                        setTermsError(err);
                    }
                } else setTermsError(err);
            });
    }

    const renderOptions = optionsData => optionsData.map((option, i) => <option key={i} value={protocolKeys[i]}> {option} </option>)

    const renderRadio = (choiceData, name) => {
        const choiceKeys = Object.keys(choiceData);
        const choices = Object.values(choiceData);

        if(choices.length > 1) {
            return choices.map(({ title }, i) => (
                <React.Fragment key={i}>
                    <input
                        id={`${name}-${i}`}
                        className={css`${radioStyle}`}
                        type='radio'
                        name={name}
                        value={choiceKeys[i]}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSelectedOption({ ...selectedOption, rescheduleDate: '', reasonOption: value, ['text-box']: selectedOption.choices[value]['text-box'] });
                            fetchTerms(value);
                        }}
                    />

                    <label htmlFor={`${name}-${i}`}>{title}</label>
                </React.Fragment>
            ))
        } else if (choices.length === 1) {
            return (
                <>
                    <input
                        id={`${name}-0`}
                        className={css`${radioStyle}`}
                        type='radio'
                        name={name}
                        value={choiceKeys[0]}
                        onChange={(e) => {
                            const value = e.target.value;
                            setSelectedOption({ ...selectedOption, reasonOption: value, ['text-box']: selectedOption.choices[value]['text-box'] });
                            fetchTerms(value);
                        }}
                    />

                    <label htmlFor={`${name}-0`}>{choices[0].title}</label>
                </>
            )
        }
    }

    const removeFile = (file, e) => {
        e.preventDefault();
        const tempArr = selectedFiles.filter(item => item.name !== file.name);
        setSelectedFiles(tempArr);
    }

    const renderFileList = (file, i) => (
        <ul key={i} className={css`${fileList}`}>
            <li className={css`${fileItem}`}>
                <p>{file.name}</p>
                <button onClick={(e) => removeFile(file, e)}><i className="icon-max-navigation-close"></i></button>
            </li>
        </ul>
    )

    return (
        <>
            <div onClick={() => closeForm()} className={css`${overlay}`}></div>

            {/* show the form modal  */}
            {!formSubmited && (
                <form className={css`${wrapper}`} style={{ display: showTerm ? "none" : "block" }}>
                    <button className={css`${closeButton}`} onClick={() => closeForm()}><i className="icon-max-navigation-close"></i></button>

                    <img className={css`${coverImage}`} src="https://website-hangar.s3.amazonaws.com/2020/02/14/protocol-cover.svg" />

                    <h3 className={css`${mainTitleStyle}`}>{title}</h3>

                    <p> { noShow
                        ? 'Como a data do seu voo já passou, só é possível fazer a remarcação dessa passagem.'
                        : 'Preencha o formulário abaixo para solicitar alteração referente à sua compra'

                    } </p>

                    <label className={css`${labelStyle}`}>
                        Selecione o motivo da sua alteração*:

                        <div className={css`${selectWrapperStyle}`}>
                            <select className={css`${selectStyle}`} ref={selectEl} onChange={() => updateSelectedReason()}>
                                {renderOptions(reasons)}
                            </select>
                            <i className='icon-arrow-down'></i>
                        </div>
                    </label>

                    {choices && (
                        <>
                            <h4 className={css`${titleStyle}`}>O que você deseja*:</h4>

                            <div className={css`${radioWrapper}`}>
                                {renderRadio(choices, 'reason-type')}
                            </div>
                        </>
                    )}

                    {/* the code above render the date selectoption for reschedule option */}
                    {isCorona && selectedOption.reasonOption === 'reschedule' && (
                        <>
                            <label className={css`${labelStyle}`}>Para qual data você quer remarcar sua viagem?*</label>

                            <Input
                                name="example_input"
                                mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                                placeholder="__/__/__"
                                onChange={(e) => {

                                    if (e.target.value.indexOf('_') !== -1) {
                                        setSelectedOption({ ...selectedOption, rescheduleDate: '' })
                                    } else {
                                        const rescheduleDate = moment(e.target.value, 'DD/MM/YYYY').format('YYYY/MM/DD')

                                        setSelectedOption({ ...selectedOption, rescheduleDate})
                                    }
                                }}
                                ref={dateInput}
                                className={css`${inputDateStyle}`}
                            />
                        </>)
                    }

                    <label className={css`${labelStyle}`}>
                        {textField && (
                            <>
                                {textField.title}
                                <textarea
                                    className={css`${textAreaStyle}`}
                                    ref={textArea}
                                    placeholder={textField.placeholder}
                                    onChange={(e) => {
                                        setSelectedOption({ ...selectedOption, justification: e.target.value });
                                    }}
                                ></textarea>
                            </>
                        )}
                    </label>

                    <ul className={css`${infoListStyle}`}>
                        {info.map((info, i) => <li key={i}><p className={css`${infoParagraphStyle}`}><i className='icon-max-communication-doubt'></i>{info}</p></li>) }
                    </ul>

                    {documents && (
                        <>
                            <h4 className={css`${titleStyle}`}>Anexe os documentos abaixo:</h4>

                            <ul className={css`${infoListStyle}`}>
                                {documents.map((document, i) => <li key={i}><p className={css`${infoParagraphStyle}`}><i className='icon-max-communication-info'></i>{document}</p></li>)}
                            </ul>

                            <hr />

                            <div>
                                {fileErrorMessage && (<p className={css`${error}`}>{fileErrorMessage}</p>)}
                                {loadingMessage && (<p className={css`${loading}`}>{loadingMessage}</p>)}
                                {selectedFiles.length >= 1 && selectedFiles.map((file, i) => renderFileList(file))}
                                {selectedFiles.length < 1 && (<p className={css`${infoParagraphStyle}`}><i className='icon-max-communication-doubt'></i>Certifique-se de que toda a documentação está legível.</p>)}
                            </div>

                            <input onChange={() => uploadFiles()} id='file-input' className={css`${fileInputStyle}`} type='file' ref={fileInput} multiple />
                            <label htmlFor='file-input'>Anexar documentos</label>
                        </>
                    )}

                    <div className={css`${error}`}>{generalError}</div>

                    {!fetchingTerms && termsError && <div className={css`${error}`}>Falha ao buscar dados, <Link href="#" onClick={e => {
                        fetchTerms(selectedOption.reasonOption);
                        e.preventDefault();
                    }}>tente novamente</Link>.</div>}

                    {!fetchingTerms && term && (
                        <>
                            <label className={css`${labelStyle}`}>Para seguir com o seu pedido, leia e confirme as condições para {selectedOption.reasonOption === "cancel" ? "cancelamento" : "remarcação"} da sua passagem {order.flights.outbound.airline}:</label>
                            <div className={css`${termsWrapper}`}>
                                <Input type='checkbox' id="check1" label=" " onChange={() => setCheckboxChecked(!isCheckboxChecked)} />
                                <p>Estou de acordo com os <a href='#' onClick={e => {
                                    setShowTerm(!showTerm);
                                    e.preventDefault();
                                }} className={css`${termsLink}`}>termos de {selectedOption.reasonOption === "cancel" ? "cancelamento" : "remarcação"}</a>.</p>
                            </div>
                        </>
                    )}

                    {!fetchingTerms && !termsError && (
                        <div className={css`${buttonWrapper}`}>
                            <Button onClick={() => closeForm()} className={css`${cancelButtonStyle}`}>Cancelar</Button>
                            <Button onClick={(e) => submitProtocol(e)} className={css`${sendButtonStyle}`} disabled={!isButtonEnable} >Enviar solicitação</Button>
                        </div>
                    )}
                </form>
            )}

            {/* show confirmation modal */}
            {formSubmited && !showTerm && (
                <div className={css`${wrapper}`}>
                    <img className={css`${coverImage}`} src="https://website-hangar.s3.amazonaws.com/2020/02/14/protocol-cover.svg" />

                    <h3 className={css`${submitedTitle}`}>Solicitação enviada!</h3>

                    <p className={css`${submitedParagraph}`}>
                        Vamos enviar seu pedido para avaliação da companhia aérea.<br/>
                        Você receberá as informações no seu e-mail e poderá<br/>
                        acompanhar os próximos passos por lá.
                    </p>

                    <p className={css`${submitedParagraph}`}>
                        { isCorona
                            ? 'Nossos canais de atendimento (telefone e chat) estão com uma grande fila de espera, sugerimos que, em caso de dúvidas, nos retorne em resposta ao e-mail recebido.'
                            : 'Se tiver alguma dúvida, entre em contato com a gente pelos nossos canais de atendimento.'
                        }
                    </p>

                    <Button onClick={() =>  window.location.pathname = "/cliente/minhas-viagens-light"} className={css`${sendButtonStyle}`}>Entendido</Button>
                </div>
            )}

            {/* show the term modal */}
            {showTerm && (<div className={css`${termWrapper}`}>
                <h4 className={css`${titleStyle}`}>Termo de acordo</h4>
                <div dangerouslySetInnerHTML={{__html: term.currentVersion.content}} />
                <div className={css`${buttonWrapper}`}>
                    <Button onClick={() => setShowTerm(!showTerm)} className={css`${cancelButtonStyle}`}>Voltar</Button>
                </div>
            </div>)}
        </>
    )
}

export default CancellationForm;
